import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-ribbon-tray',
	templateUrl: './ribbon-tray.component.html',
	styleUrls: ['./ribbon-tray.component.scss'],
})
export class RibbonTrayComponent {

	@Input() isOpen: boolean = false;
	@Input() title: string = '';

	@Output() close = new EventEmitter<void>();

	onOverlayClick(): void {
		this.close.emit();
	}

	onCloseClick(): void {
		this.close.emit();
	}

}
